const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const config = { ...options };
  
  // Set default headers, but allow overriding
  if (!config.headers) {
    config.headers = {};
  }
  
  // Only set Content-Type to application/json if:
  // 1. It's not already set by the caller
  // 2. The body is not FormData (which needs its own content-type with boundary)
  if (!config.headers['Content-Type'] && !(options.body instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }
  
  // If the body is FormData, let the browser set the Content-Type automatically
  // by removing any manually set Content-Type
  if (options.body instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  
  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      let errorData = {};
      
      try {
        errorData = await response.json();
        
        // If it's a resource limit error (quota), use exactly the same handling as before
        if (errorData.error === 'Resource limit reached') {
          throw new Error(errorData.message || 'Resource limit reached. You have used all your available AI generation requests for this billing period.');
        }
      } catch (e) {
        // If JSON parsing fails or we already have a resource limit error, continue
        if (e.message && e.message.includes('Resource limit reached')) {
          throw e; // Re-throw resource limit errors
        }
      }
     
      const friendlyMessages = {
        400: "The request contains invalid data. Please check your input and try again.",
        401: "Your session has expired. Please sign in again to continue.",
        403: "You don't have permission to access this feature. Please check your subscription status or contact support.",
        404: "The requested resource was not found. Please verify the information and try again.",
        500: "An issue occurred. Please try again in a few minutes. If the problem persists, contact support.",
        503: "The service is temporarily unavailable. Please try again in a few minutes."
      };

      const friendlyMessage = friendlyMessages[response.status] || 
                        "An unexpected error occurred. Please try again or contact support.";      
      throw new Error(friendlyMessage);
    }
    
    return response;
  } catch (error) {
    
    if (error.message === 'Failed to fetch') {
      throw new Error('Unable to connect to the server. Please check your internet connection and try again.');
    }    
    // Rethrow all other errors
    throw error;
  }
};

// Add this function to check for resource limit errors
export const checkForResourceLimitError = async (response) => {
  if (!response.ok) {
    try {
      const errorData = await response.json();
      if (errorData.error === 'Resource limit reached') {
        throw new Error(errorData.message || 'Resource limit reached. You have used all your available AI generation requests for this billing period.');
      }
      throw new Error(errorData.message || errorData.error || 'Request failed');
    } catch (parseError) {
      if (parseError.message.includes('Resource limit reached')) {
        throw parseError;
      }
      throw new Error('Failed to generate content');
    }
  }
  return response;
};